import { useEffect, useState } from 'react';
import { useTeams } from '../../lib/teams';
import { refreshStructure, useNav, type Target } from '../../lib/structure';
import { queryClient } from '../../lib/board';
import { navigate } from '../../lib/router';
import { PlacementSelect } from '../home/PlacementSelect';

export const fieldClass = 'min-h-11 w-full rounded-lg border border-[var(--line)] bg-[var(--panel)] px-3 text-base font-normal sm:min-h-10 sm:text-sm';

/** Ablage und Team für neue und importierte Boards (B01, A03) */
export function useBoardTarget(open: boolean, target: Target | null | undefined) {
  const { data: teams } = useTeams(open);
  const { data: nav } = useNav(open);
  const [place, setPlace] = useState<Target>({ areaId: null, folderId: null });
  const [teamId, setTeamId] = useState('');
  useEffect(() => {
    if (open) setPlace(target ?? { areaId: null, folderId: null });
  }, [open, target]);
  useEffect(() => {
    // Ohne Auswahl: das einzige Team, sonst „ohne Team“
    if (open && teams) setTeamId(teams.length === 1 ? teams[0]!.id : '');
  }, [open, teams]);
  const placeArea = nav?.areas.find((a) => a.id === place.areaId);
  return {
    nav,
    teams,
    place,
    setPlace,
    teamId,
    setTeamId,
    placeArea,
    body: { teamId: placeArea ? placeArea.teamId : teamId || null, areaId: place.areaId, folderId: place.folderId },
  };
}

export function TargetFields({ t, idPrefix }: { t: ReturnType<typeof useBoardTarget>; idPrefix: string }) {
  return (
    <>
      {!!t.nav?.areas.length && (
        <div className="flex flex-col gap-1.5 text-sm font-medium">
          <label htmlFor={`${idPrefix}-place`}>Ablage</label>
          <PlacementSelect id={`${idPrefix}-place`} nav={t.nav} value={t.place} onChange={t.setPlace} />
        </div>
      )}
      {!!t.teams?.length && !t.placeArea && (
        <label className="flex flex-col gap-1.5 text-sm font-medium">
          Team
          <select value={t.teamId} onChange={(e) => t.setTeamId(e.target.value)} className={fieldClass}>
            {t.teams.map((x) => (
              <option key={x.id} value={x.id}>
                {x.name}
              </option>
            ))}
            <option value="">Ohne Team</option>
          </select>
        </label>
      )}
    </>
  );
}

/** Nach dem Anlegen: Listen auffrischen und ins neue Board wechseln */
export async function openNewBoard(boardId: string, close: () => void) {
  refreshStructure();
  await queryClient.invalidateQueries({ queryKey: ['boards'] });
  close();
  navigate(`/b/${boardId}`);
}
